import { isDebugMode, log } from './log';

declare global {
  interface Window {
    pixelsbjs: any;
  }
}

let prebidInited = false;

const loadPrebidLib = () => {
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.defer = true;
    script.onload = () => resolve(1);
    script.src = 'https://pub.pixels.ai/prebid_standard.js';
    document.head.appendChild(script);
  });
};

export const runPrebid = async (jwPlayerDomId: string, jwMediaId: string, iu: string): Promise<string> => {
  if (!prebidInited) {
    await loadPrebidLib();
    prebidInited = true;
    log('pixels', 'runPrebid', 'prebid lib loaded');
  }
  log('pixels', 'runPrebid', 'called with media Id', jwMediaId);
  return new Promise(resolve => {
    const { pixelsbjs } = window;
    const videoAdUnit = {
      code: 'video1',
      mediaTypes: {
        video: {
          context: 'instream',
          playerSize: [[640, 480]],
          mimes: ['video/mp4'],
          protocols: [1, 2, 3, 4, 5, 6, 7, 8],
          playbackmethod: [2],
          skip: 1,
          placement: 1,
          plcmt: 1,
          api: [1, 2, 3, 4, 5],
          linearity: 1,
        },
      },
      bids: [
        {
          bidder: 'appnexus',
          params: {
            placementId: 28358412,
          },
        },
        {
          bidder: 'gridNM',
          params: {
            source: 'jwp',
            secid: '11', // arbitrary value; not used
            pubid: 'JslU7maJ', // supplied by jw/grid
            video: {
              mimes: ['video/mp4', 'video/x-ms-wmv'],
              protocols: [1, 2, 3, 4, 5, 6],
            },
          },
        },
        {
          bidder: 'pubmatic',
          params: {
            publisherId: '160736',
            adSlot: 'eveningstandard_prebid_video',
          },
        },
        {
          bidder: 'ix',
          params: {
            siteId: '925705',
          },
        },
        {
          bidder: 'rubicon',
          params: {
            accountId: '17292',
            siteId: '457280',
            zoneId: '2678902',
          },
        },
        {
          bidder: 'ozone',
          params: {
            publisherId: 'OZONEESI0002',
            siteId: '4204204244',
            placementId: '1500000197',
          },
        },
      ],
      ortb2Imp: {
        ext: {
          data: {
            jwTargeting: {
              playerID: jwPlayerDomId,
              mediaID: jwMediaId,
            },
          },
        },
      },
    };
    const priceGranularity = {
      buckets: [
        {
          precision: 2,
          min: 0,
          max: 3,
          increment: 0.01,
        },
        {
          precision: 2,
          min: 3,
          max: 8,
          increment: 0.05,
        },
        {
          precision: 2,
          min: 8,
          max: 20,
          increment: 0.5,
        },
        {
          precision: 2,
          min: 20,
          max: 35,
          increment: 1.0,
        },
      ],
    };
    /* Log when ad units are added to Prebid */
    pixelsbjs.onEvent('addAdUnits', () => {
      log('pixels', 'addAdUnits event', pixelsbjs.adUnits);
    });

    /* Log when Prebid wins the ad server auction */
    pixelsbjs.onEvent('bidWon', (data: any) => {
      log(
        'pixels',
        'bidWon event',
        data.bidderCode + ' won the ad server auction for ad unit ' + data.adUnitCode + ' at ' + data.cpm + ' CPM'
      );
    });
    pixelsbjs.que.push(() => {
      pixelsbjs.addAdUnits(videoAdUnit); // add your ad units to the bid request
      pixelsbjs.setConfig({
        debug: isDebugMode() ? true : false,
        priceGranularity,
        cache: {
          url: 'https://prebid.adnxs.com/pbc/v1/cache',
          ignoreBidderCacheKey: false,
        },
        consentManagement: {
          gdpr: {
            cmpApi: 'iab',
            timeout: 2000,
            defaultGdprScope: true,
          },
          usp: {
            cmpApi: 'iab',
            timeout: 100,
          },
        },
        realTimeData: {
          auctionDelay: 100,
          dataProviders: [
            {
              name: 'jwplayer',
              waitForIt: true,
              params: {
                mediaIDs: [jwMediaId],
              },
            },
          ],
        },
      });
      pixelsbjs.requestBids({
        bidsBackHandler: (bids: any) => {
          log('pixels', 'buildVideoUrl', iu);
          const videoUrl = pixelsbjs.adServers?.dfp.buildVideoUrl({
            adUnit: videoAdUnit,
            params: {
              iu,
              cust_params: {},
              output: 'vast',
            },
          });
          resolve(videoUrl);
        },
      });
    });
    pixelsbjs.bidderSettings = {
      standard: {
        storageAllowed: true,
      },
    };
  });
};
